// import { login, logout, getInfo } from '@/api/login'
import http from "@/utils/httpRequest.js";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { handleTree } from "@/utils/comm";
const user = {
  state: {
    token: getToken(),
    name: "",
    comId: "", //机构id
    // 登录状态
    loginStatus: 0,

    routerList: JSON.parse(sessionStorage.getItem("routerList")) || [],
    userComInfo: JSON.parse(sessionStorage.getItem("userInfo")) || null,
    navList: JSON.parse(sessionStorage.getItem("navList1")) || [
      { name: "我的企业", path: "/user" },
      { name: "企业信息", path: "/com/comInfo" }
    ]
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },

    SET_ROUTERLIST: (state, routerList) => {
      state.routerList = routerList;
    },
    SET_NAVLIST: (state, navList) => {
      sessionStorage.setItem("navList1", JSON.stringify(navList));
      state.navList = navList;
    },
    SET_USER: (state, userComInfo) => {
      sessionStorage.setItem("userInfo", JSON.stringify(userComInfo));
      state.userComInfo = userComInfo;
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim();
      const password = userInfo.password;
      return new Promise((resolve, reject) => {
        http({
          url: http.adornUrl("/login"),
          method: "post",
          data: userInfo
        })
          .then(res => {
            if (res.data.code == 200) {
              setToken(res.data.token);
              commit("SET_TOKEN", res.data.token);
            }
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 登录
    ThreeLogin({ commit }, enterpriseId) {
      return new Promise((resolve, reject) => {
        http({
          url: http.adornUrl("/identity/login/" + enterpriseId),
          method: "get"
        })
          .then(res => {
            console.log(res);
            if (res.data.code == 200) {
              setToken(res.data.token);
              commit("SET_TOKEN", res.data.token);
            }
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    smsLogin({ commit }, userInfo) {
      const mobilePhone = userInfo.mobilePhone.trim();
      const activeCode = userInfo.activeCode;
      return new Promise((resolve, reject) => {
        http({
          url: http.adornUrl("/sms/login"),
          method: "post",
          data: userInfo
        })
          .then(res => {
            setToken(res.data.token);
            commit("SET_TOKEN", res.data.token);
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        http({
          url: http.adornUrl("/getInfo"),
          method: "get"
        })
          .then(res => {
            const user = res.data.user;
            commit("SET_USER", user);
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        http({
          url: http.adornUrl("/logout"),
          method: "post"
        })
          .then(res => {
            commit("SET_TOKEN", "");
            removeToken();
            sessionStorage.setItem("userInfo", null);
            sessionStorage.removeItem("checkDue");
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit("SET_TOKEN", "");
        removeToken();
        resolve();
      });
    },

    // 路由
    // 这里拿路由的时候做处理
    GenerateRoutes({ commit }) {
      return new Promise((resolve, reject) => {
        // 向后端请求路由数据
        http({
          url: http.adornUrl("/getRouters"),
          method: "get"
        })
          .then(res => {
            console.log(res)

            var isServiceOrg = user.state.userComInfo.isServiceOrg;
            res.data.data.forEach(e => {
              // 切换就是改变isHidden的状态就好了
              // isServiceOrg 本身就是判断是否是服务机构
              // e.menuId == 2001000 && isServiceOrg == true  服务机构的时候这2个特殊处理
              if (e.menuId == 2000000 || e.parentId == 2000000) {
                e.isHidden = false;
              } else {
                e.isHidden = true;
              }
              e.path = "/" + e.path;
            });
            var newRouter = handleTree(res.data.data, "menuId");
            sessionStorage.setItem("routerList", JSON.stringify(newRouter));
            console.log(newRouter)
            // 这里是你拿到的路由，点击切换的时候从缓存里面拿，然后更新
            commit("SET_ROUTERLIST", newRouter);
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js